<template>
  <v-row no-gutters>
    <h2>{{ heading }}</h2>
    <v-spacer></v-spacer>
    <slot name="org-page-button"></slot>
  </v-row>
</template>
<script>
export default {
  props: {
    heading: String
  }
};
</script>
